// constants
import { AuthActionTypes } from './constants';

export type AuthActionType = {
    type:
        | AuthActionTypes.API_RESPONSE_SUCCESS
        | AuthActionTypes.API_RESPONSE_ERROR
        | AuthActionTypes.FORGOT_PASSWORD
        | AuthActionTypes.FORGOT_PASSWORD_CHANGE
        | AuthActionTypes.LOGIN_USER
        | AuthActionTypes.LOGOUT_USER
        | AuthActionTypes.RESET
        | AuthActionTypes.SIGNUP_USER;
    payload: {} | string;
};

type UserData = {
    Active: boolean;
    Address: string;
    CompanyId: number;
    CompanyName: string;
    CompanyStatus: number;
    Email: string;
    IdentificationNumber: string;
    IdentificationType: number;
    IsCertificated: boolean;
    Phone: string;
    UserName: string;
    WebSiteUrl: string;
    expiration: string;
    Password: string;
   // role: string;
    token: string;
};

// common success
export const authApiResponseSuccess = (actionType: string, data: UserData | {}): AuthActionType => ({
    type: AuthActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const authApiResponseError = (actionType: string, error: string): AuthActionType => ({
    type: AuthActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const loginUser = (Username: string, Password: string): AuthActionType => ({
    type: AuthActionTypes.LOGIN_USER,
    payload: { Username, Password },
});

export const logoutUser = (): AuthActionType => ({
    type: AuthActionTypes.LOGOUT_USER,
    payload: {},
});

export const signupUser = (CompanyName: string, Email: string, Password: string): AuthActionType => ({
    type: AuthActionTypes.SIGNUP_USER,
    payload: { CompanyName, Email, Password },
});

export const forgotPassword = (Email: string): AuthActionType => ({
    type: AuthActionTypes.FORGOT_PASSWORD,
    payload: { Email },
});

export const resetAuth = (): AuthActionType => ({
    type: AuthActionTypes.RESET,
    payload: {},
});
